import type * as React from 'react';
import { post } from '@Domain/Api';
import type { DocumentTypePayload } from '@Application/Documents/DocumentTypes/Actions/documentTypesFetched';
import documentTypeCreated, {
	type DocumentTypeCreatedAction,
} from '@Application/Documents/DocumentTypes/Actions/documentTypeCreated';
import documentTypeCreationFailed, {
	type DocumentTypeCreationFailedAction,
} from '@Application/Documents/DocumentTypes/Actions/documentTypeCreationFailed';
import type CreateDocumentType from '@Application/Documents/DocumentTypes/Commands/CreateDocumentType';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = DocumentTypeCreatedAction | DocumentTypeCreationFailedAction;

export default (command: CreateDocumentType) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<DocumentTypePayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/document-types`,
				command.toJSON(),
			);

			const action = documentTypeCreated(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentTypeCreationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
